import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/catalog/TitleGrid";
import { formatApiError } from "@/lib/api";

export default function AuthCallback() {
  const { completeGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    completeGoogle(sessionId)
      .then(() => navigate("/profiles", { replace: true }))
      .catch((e) => {
        toast.error(formatApiError(e));
        navigate("/login", { replace: true });
      });
  }, [completeGoogle, navigate]);

  return <div className="min-h-screen bg-[#050505]" data-testid="auth-callback"><Spinner /></div>;
}
